import { MuggleMixin, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import FormFieldComponent from '../form-field/form-field.vue.js';
import '../form-field/index.js';

/**
 * Component that renders an input field type password by default. The user
 * can interact with this component by clicking on peek password icon. That
 * kind of interaction toggles input field type password to text and as an
 * result shows password to the user as a plain text.
 */
var PeekPasswordComponent = /** @class */ (function (_super) {
    __extends(PeekPasswordComponent, _super);
    function PeekPasswordComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Represents whether the password is
         * shown or hidden.
         */
        _this.isShown = false;
        /**
         * Whether the input should be focused
         */
        _this.focused = false;
        /**
         * Timer for mask password
         */
        _this.timer = null;
        return _this;
    }
    /**
     * Toggles between showing and hiding the
     * password.
     */
    PeekPasswordComponent.prototype.togglePassword = function () {
        var _this = this;
        this.isShown = !this.isShown;
        this.focused = false;
        this.$nextTick(function () {
            _this.focused = true;
        });
    };
    /**
     * Mask password 3 seconds after
     * the user has stopped typing.
     */
    PeekPasswordComponent.prototype.maskPassword = function (active) {
        var _this = this;
        this.timer && clearTimeout(this.timer);
        this.isShown = active;
        active &&
            (this.timer = setTimeout(function () {
                _this.isShown = false;
            }, 3000));
    };
    PeekPasswordComponent.prototype.onShownChange = function (shown) {
        this.isShown = shown;
    };
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], PeekPasswordComponent.prototype, "unmaskPassword", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PeekPasswordComponent.prototype, "shown", void 0);
    __decorate([
        Watch('shown', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], PeekPasswordComponent.prototype, "onShownChange", null);
    PeekPasswordComponent = __decorate([
        Component({
            name: 'ui-peek-password',
            inheritAttrs: false,
            components: {
                'ui-form-field': FormFieldComponent,
            },
        })
    ], PeekPasswordComponent);
    return PeekPasswordComponent;
}(Mixins(MuggleMixin, MagicConfigMixin)));

export default PeekPasswordComponent;
